
import {Component, Watch} from 'vue-property-decorator';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import NYCXDiscountByItemCodeTable from '@/components/reports-v3/components/codedWidgets/custom/nycx/NYCXDiscountByItemCodeTable.vue';
import NYCXDiscountByTotalTable from '@/components/reports-v3/components/codedWidgets/custom/nycx/NYCXDiscountByTotalTable.vue';

@Component({
    components: {
        NYCXDiscountByTotalTable,
        NYCXDiscountByItemCodeTable,
    },
})

export default class NYCXCustomDashboard extends FilterWidget {

}
